import { render, staticRenderFns } from "./ScarAdd.vue?vue&type=template&id=261027fd&scoped=true"
import script from "./ScarAdd.vue?vue&type=script&lang=js"
export * from "./ScarAdd.vue?vue&type=script&lang=js"
import style0 from "./ScarAdd.vue?vue&type=style&index=0&id=261027fd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "261027fd",
  null
  
)

export default component.exports